export const toCamelCase = (str: string): string => {
    return str
        .replace(/([a-z])([A-Z])/g, '$1 $2') // Вставляем пробел перед заглавными буквами
        .replace(/^./, (match) => match.toUpperCase()); // Делаем первую букву заглавной
}
